module.exports = __webpack_public_path__ + "media/components/spaces/spaces_empty-236895a3ce88fcc8bc775801e07f43b7.svg";